<isophi-info-popup
  *transloco="let t"
  [title]="t('popup/innitial/title')"
  [continueLabel]="t('popup/innitial/continue')"
  [(dontShowAgain)]="dontShowAgain"
  (closed)="close()"
>
  <div class="text-wrapper">
    <div [innerHTML]="t('popup/innitial/text1')"></div>
    <div [innerHTML]="t('popup/innitial/text2')"></div>
    <div [innerHTML]="t('popup/innitial/text3')"></div>
    <div [innerHTML]="t('shared/popup/contact')"></div>
  </div>
</isophi-info-popup>
